import { Host, h } from "@stencil/core";
import { toString } from "../../utils/utils";
import { FallbackRenderInfo } from "../../utils/FallbackRenderInfo";
export class ApieSingleInput {
    constructor() {
        this.name = undefined;
        this.label = null;
        this.value = undefined;
        this.types = '';
        this.renderInfo = new FallbackRenderInfo();
        this.additionalSettings = {};
        this.serverValidationError = {};
        this.internalState = {};
        this.allowsNull = false;
        this.emptyStringAllowed = false;
        this.required = false;
        this.isTouched = false;
        this.validationResult = {
            valid: true,
            messages: []
        };
    }
    sanitizeInput(newValue) {
        if (newValue === '') {
            if (!this.emptyStringAllowed && this.allowsNull) {
                return null;
            }
        }
        if (newValue === null) {
            if (!this.allowsNull && this.emptyStringAllowed) {
                return '';
            }
        }
        return newValue;
    }
    renderInput() {
        if (this.value === undefined) {
            Promise.resolve().then(() => {
                this.triggerChange.emit({ name: this.name, value: this.sanitizeInput(null) });
            });
        }
        return this.renderInfo.renderSingleInput(this.types.split(','), {
            name: this.name,
            label: this.label,
            value: this.value,
            additionalSettings: this.additionalSettings,
            valueChanged: (newValue) => {
                newValue = this.sanitizeInput(newValue);
                if (newValue !== this.value) {
                    this.value = newValue;
                    this.triggerChange.emit({ name: this.name, value: newValue });
                }
            },
            validationResult: this.validationResult,
            serverValidationError: this.serverValidationError,
            renderInfo: this.renderInfo,
            currentFieldWrapper: this.renderInfo.createFieldWrapper(),
            allowsNull: this.allowsNull,
            emptyStringAllowed: this.emptyStringAllowed,
            required: this.required,
            touched: this.isTouched,
            onTouched: () => { this.isTouched = true; this.touched.emit(); },
            internalState: toString(this.internalState),
            internalStateChanged: (newValue) => {
                this.internalState = newValue;
                this.internalStateChanged.emit(this.internalState);
            }
        });
    }
    render() {
        return (h(Host, { key: '827e116723e46ccc86dd19c15b7930f850b19921' }, this.renderInput(), h("slot", { key: 'c406e70fba300fa8b00dba9a4b9c4537afc628ef' })));
    }
    static get is() { return "apie-single-input"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["apie-single-input.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["apie-single-input.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "name",
                "reflect": true
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "label",
                "reflect": true,
                "defaultValue": "null"
            },
            "value": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string | null",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "value",
                "reflect": true
            },
            "types": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "types",
                "reflect": true,
                "defaultValue": "''"
            },
            "renderInfo": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "RenderInfo",
                    "resolved": "RenderInfo",
                    "references": {
                        "RenderInfo": {
                            "location": "import",
                            "path": "../../utils/RenderInfo",
                            "id": "src/utils/RenderInfo.tsx::RenderInfo"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "new FallbackRenderInfo()"
            },
            "additionalSettings": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "SingleFieldSettings",
                    "resolved": "SingleFieldSettings",
                    "references": {
                        "SingleFieldSettings": {
                            "location": "import",
                            "path": "../../components",
                            "id": "src/components.d.ts::SingleFieldSettings"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "{}"
            },
            "serverValidationError": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "NestedRecord<string>",
                    "resolved": "{ [key: string]: NestedRecordField<string>; }",
                    "references": {
                        "NestedRecord": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::NestedRecord"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "{}"
            },
            "internalState": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "internal-state",
                "reflect": true,
                "defaultValue": "{}"
            },
            "allowsNull": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "allows-null",
                "reflect": true,
                "defaultValue": "false"
            },
            "emptyStringAllowed": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "empty-string-allowed",
                "reflect": true,
                "defaultValue": "false"
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "required",
                "reflect": true,
                "defaultValue": "false"
            },
            "validationResult": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "ValidationResult",
                    "resolved": "ValidationResult",
                    "references": {
                        "ValidationResult": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::ValidationResult"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "{\n    valid: true,\n    messages: []\n  }"
            }
        };
    }
    static get states() {
        return {
            "isTouched": {}
        };
    }
    static get events() {
        return [{
                "method": "internalStateChanged",
                "name": "internalStateChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "touched",
                "name": "touched",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "ChangeEvent",
                    "resolved": "ChangeEvent",
                    "references": {
                        "ChangeEvent": {
                            "location": "import",
                            "path": "../../utils/utils",
                            "id": "src/utils/utils.ts::ChangeEvent"
                        }
                    }
                }
            }, {
                "method": "triggerChange",
                "name": "triggerChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "ChangeEvent",
                    "resolved": "ChangeEvent",
                    "references": {
                        "ChangeEvent": {
                            "location": "import",
                            "path": "../../utils/utils",
                            "id": "src/utils/utils.ts::ChangeEvent"
                        }
                    }
                }
            }];
    }
}
//# sourceMappingURL=apie-single-input.js.map
